<div class="cardLayout">
  <ion-row>
    <ion-col size="12">
      <div class="popup-heading">
        <div>
          <p class="fs-16 font_regular">Eligible employees</p>
         </div>
         <div class="popup-close">
          <div class="mr-30"> 
            
            <label class="fs-16 font_regular mr-15">Male ({{maleTotalCount || 0}})</label>
          <mat-slide-toggle class="toggle-element mr-20" [(ngModel)]="isToggleChecked"></mat-slide-toggle>
          <label class="fs-16 font_regular">Female ({{FeMaleTotalCount || 0}})</label>
          </div>
          <button class="download-btn" (click)="exportToExcel()">
            <span class="ml-5 mr-5 fs-12 material-icons">arrow_downward</span>
            download
          </button>
          <span [mat-dialog-close] class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
        </div>
      </div>
 
    </ion-col> 
  </ion-row>

  <ion-row>
    <ion-col size="12">
      <div class="table-container" *ngIf="!isToggleChecked">
      <table class="Market-correction-employees-table" id="maleData">
        <thead>
          <tr>
            <th class="fs-14 font_bold cl-black">
              <div class="icon-style">
                Department
              </div>
            </th>
            <th class="fs-14 font_bold cl-black">
              <div class="icon-style">
                Band
              </div>
            </th>
            <th class="fs-14 font_bold cl-black">
              <div class="icon-style">
                Employee
              </div>
            </th>
            <th class="fs-14 font_bold cl-black">
              <div class="icon-style">
                Manager
              </div>
            </th>
            <th class="fs-14 font_bold cl-black">
              <div class="icon-style">
                HOD
              </div>
            </th>
            <th class="fs-14 font_bold cl-black">
              <div class="icon-style">
                DOJ
              </div>
            </th>
            <th class="fs-14 font_bold cl-black">
              <div class="icon-style">
                eligible emp
              </div>
            </th>
            <th class="fs-14 font_bold cl-black">
              <div class="icon-style">
                days served in the increment period
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let department of getEligibleMaleEmployeeData">
            <ng-container *ngFor="let band of department.bandGrades; let i = index">
              <ng-container *ngFor="let employee of band.employeeData; let j = index">
                <tr>
                  <td *ngIf="i === 0 && j === 0" [attr.rowspan]="getTotalRowSpan(department.bandGrades)">
                    {{department.departmentName}}
                  </td>
                  <td *ngIf="j === 0" [attr.rowspan]="band.employeeData.length">
                    {{ band.band }}
                  </td>
                  <td>{{employee.employeeName}}</td>
                  <td>{{employee.managerName}}</td>
                  <td>{{employee.hodName}}</td>
                  <td>{{employee.dateOfJoining | date: 'dd-MM-yyyy'}}</td>
                  <td>{{employee.isEligible ? "Yes" : "No"}}</td>
                  <td>{{employee.daysServed | number}}</td>
                </tr>
              </ng-container>
            </ng-container>
          </ng-container>
       </tbody>
       <tfoot>
        <tr>
          <td colspan="7" class="total">Total</td>
          <td class="total">{{countMaleDaysServedTotal | number}}</td>
        </tr>
       </tfoot>
      </table>
      </div>

      <div class="table-container" *ngIf="isToggleChecked">
        <table class="Market-correction-employees-table"  id="feMaleData">
          <thead>
            <tr>
              <th class="fs-14 font_bold cl-black">
                <div class="icon-style">
                  Department
                </div>
              </th>
              <th class="fs-14 font_bold cl-black">
                <div class="icon-style">
                  Band
                </div>
              </th>
              <th class="fs-14 font_bold cl-black">
                <div class="icon-style">
                  Employee
                </div>
              </th>
              <th class="fs-14 font_bold cl-black">
                <div class="icon-style">
                  Manager
                </div>
              </th>
              <th class="fs-14 font_bold cl-black">
                <div class="icon-style">
                  HOD
                </div>
              </th>
              <th class="fs-14 font_bold cl-black">
                <div class="icon-style">
                  DOJ
                </div>
              </th>
              <th class="fs-14 font_bold cl-black">
                <div class="icon-style">
                  Eligible emp
                </div>
              </th>
              <th class="fs-14 font_bold cl-black">
                <div class="icon-style">
                  Days served in the increment period
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let department of getEligibleFeMaleEmployeeData">
              <ng-container *ngFor="let band of department.bandGrades; let i = index">
                <ng-container *ngFor="let employee of band.employeeData; let j = index">
                  <tr>
                    <td *ngIf="i === 0 && j === 0" [attr.rowspan]="getTotalRowSpan(department.bandGrades)">
                      {{department.departmentName}}
                    </td>
                    <td *ngIf="j === 0" [attr.rowspan]="band.employeeData.length">
                      {{ band.band }}
                    </td>
                    <td>{{employee.employeeName}}</td>
                    <td>{{employee.managerName}}</td>
                    <td>{{employee.hodName}}</td>
                    <td>{{employee.dateOfJoining | date: 'dd-MM-yyyy'}}</td>
                    <td>{{employee.isEligible ? "Yes" : "No"}}</td>
                    <td>{{employee.daysServed | number}}</td>
                  </tr>
                </ng-container>
              </ng-container>
            </ng-container>
         </tbody>
         <tfoot>
          <tr>
            <td colspan="7" class="total">Total</td>
            <td class="total">{{countFeMaleDaysServedTotal | number}}</td>
          </tr>
         </tfoot>
        </table>
        </div>
    </ion-col>
  </ion-row> 
</div>